import { render, staticRenderFns } from "./Artigos.vue?vue&type=template&id=5133a938&"
import script from "./Artigos.vue?vue&type=script&lang=js&"
export * from "./Artigos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports